// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3h7mz","inner":"Footer_inner__FPpkf","nextIcon":"Footer_nextIcon__2R0zI","innerLeft":"Footer_innerLeft__38Hdc"};